import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SocialButton from '@components/login/SocialButton';
const LineSigninButton = (props) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    if (window.country !== 'JP') {
        return React.createElement(React.Fragment, null);
    }
    // Line OpenID Connect demands the previous user consent in order to get the user's email, so we need to show the modal (implemented but not used)
    return (
    // <>
    //   <button
    //     aria-label={props.register ? t('signup.line') : t('signin.line')}
    //     type="button"
    //     onClick={() => {
    //       // send analytics social btn clicked
    //       props.from === 'wishlist'
    //         ? analytics.socialLoginGeneric({ event: 'popup', eventCategory: 'popup', eventAction: 'line-login', eventLabel: 'open' })
    //         : analytics.socialLoginGeneric({ eventAction: 'line-login' });
    //       setShowModal(true);
    //     }}
    //     className={classNames('button social-button', `button--${props.secondary ? 'secondary' : 'link'}`)}
    //   >
    //     <>
    //       <div className="icon--social-line"></div>
    //       {props.register ? t('signup.line') : t('signin.line')}
    //     </>
    //   </button>
    //   {
    //     showModal && (
    //       <ModalDialog
    //         className="modal--small confirm-changepassword"
    //         isOpen={showModal}
    //         contentLabel={t('linesignin.modal.title')}
    //         onRequestClose={() => setShowModal(false)}
    //       >
    //         <>
    //           <p dangerouslySetInnerHTML={{ __html: t('linesignin.modal.content') }} />
    React.createElement(SocialButton, { social: "line", analyticsKey: "earlyAccess", from: props.from, register: props.register, secondary: props.secondary, reloadTarget: props.reloadTarget, reloadUrl: props.reloadUrl, setIsLoading: props.setIsLoading })
    //         </>
    //       </ModalDialog>
    //     )}
    // </>
    );
};
export default LineSigninButton;
